<template>
  <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div class="card-header py-3 pregunta-rang-enunciat">
            <h6 class="m-0 font-weight-bold text-primary">{{this.numPregunta}}. {{pregunta.enunciat | etiqueta}}</h6>
          </div>
          <!-- Card Body -->
          <div class="card-body pregunta-rang-resposta">
            <b-form-input @change="onChange" id="input-7" v-model="valor" type="range" :min="pregunta.atributsResposta.limitInferior" :max="pregunta.atributsResposta.limitSuperior" step="1"></b-form-input>        
            <div class="font-weight-bold">{{ valor }}</div>
            <div class="font-weight-bold" style="color:red;" v-show="noinformat">{{$t('enquestes.rang')}}</div>
          </div>
 </div>
 
</template>

<script>
export default {
  name: "pregunta-rang",
  props: {
    pregunta:{
      type: Object,
      required: true
    },
    valorInicial:{
      type: String,
      required: true
    },
    numPregunta:{
      type: String,
      required: true
    },
    idPregunta:{
      type: Number,
      required: true
    } 
  },   
  data() {
    return {
      valor : null,
      noinformat : false
    };
  },
  methods: {
    validate(){
      if(this.valor!=''){
        this.noinformat = false;
        return true;
      }else{
        this.noinformat = true;
        return false;
      }

    },getValor(){
        return this.valor;
    },
    onChange(){      
      if(this.valor!=''){
        this.noinformat = false;      
      }else{
        this.noinformat = true;
      }   
    },getIdPregunta(){
      return this.idPregunta;
    }        
  },
  mounted() {  
    if(this.valorInicial!=''){
      this.valor = parseInt(this.valorInicial);
      this.noinformat = false;
    }else{
      this.valor = '';
      this.noinformat = true;
    }      
  }
};
</script>
<style>
.pregunta-rang-enunciat{
  text-align: left;
}
.pregunta-rang-resposta{
  text-align: center;
}
</style>